<custom-sidebar
  heading="Collegamenti"
  [routes]="sidebarRoutes$ | async"
  contentMode="ng-content"
  position="start"
  [opened]="false"
>
  <div class="home-shell container-fluid">
    <div class="hero-panel">
      <div class="row align-items-center">
        <div class="col-lg-7 col-12">
          <p class="eyebrow">Benvenuto {{ user?.nome || "" }}</p>
          <h1>Start Claims</h1>
          <p class="lede">
            Piattaforma peritale per la gestione di sinistri assicurativi
          </p>

          <div class="hero-badges">
            <a
              class="metric-tile cta"
              *ngIf="incarichiInCorsoCount != null"
              routerLink="/incarichi/lavori-in-corso"
            >
              <span class="label">Lavori in Corso</span>
              <span class="value">{{ incarichiInCorsoCount }}</span>
            </a>
            <a
              class="metric-tile cta"
              *ngIf="IncarichiInAttesaSopralluogoCount != null"
              routerLink="/incarichi/in-attesa-di-sopralluogo"
            >
              <span class="label">Sopralluoghi</span>
              <span class="value">{{ IncarichiInAttesaSopralluogoCount }}</span>
            </a>
            <a
              class="metric-tile accent cta"
              *ngIf="incarichiUrgenti?.length"
              (click)="openIncarichiUrgentiModal()"
            >
              <span class="label">Urgenti</span>
              <span class="value">{{ incarichiUrgenti.length }}</span>
            </a>
          </div>
        </div>

        <div class="col-lg-5 col-12 mt-4 mt-lg-0">
          <div class="hero-visual">
            <div class="logo-stack">
              <div
                class="logo"
                *ngIf="user?.studio_id == 1 || user?.studio_id == 2"
              >
                <img src="/imgs/start.png" alt="Start" />
              </div>
              <div class="logo logo-secondary" *ngIf="user?.studio_id == 1">
                <img src="/imgs/peritek.png" alt="Peritek" />
              </div>
              <div class="logo logo-secondary" *ngIf="user?.studio_id == 3">
                <img src="/imgs/gsa.png" alt="GSA" />
              </div>
              <div class="logo logo-secondary" *ngIf="user?.studio_id == 2">
                <img src="/imgs/nexus.jpg" alt="Nexus" />
              </div>
              <div class="logo logo-secondary" *ngIf="user?.studio_id == 3">
                <img src="/imgs/help-claims.png" alt="Help Claims" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="incarichiUrgenti && incarichiUrgenti.length > 0"
      class="urgent-ribbon mt-4"
    >
      <div class="urgent-content">
        <div class="d-flex align-items-center urgent-left">
          <div class="pulse"></div>
          <div>
            <p class="warning-text mb-0">
              Hai <b>{{ incarichiUrgenti.length }}</b> incarichi urgenti
            </p>
            <small>Rivedi ora per non perdere le scadenze</small>
          </div>
        </div>
        <button
          mat-flat-button
          color="warn"
          (click)="openIncarichiUrgentiModal()"
        >
          Visualizza
        </button>
      </div>
    </div>

    <div class="section-header mt-4">
      <div>
        <h5>Navigazione Rapida</h5>
        <p class="section-sub">Accedi subito alle aree che usi di più</p>
      </div>
      <mat-divider></mat-divider>
    </div>

    <div class="row card-grid">
      <div class="card-wrapper">
        <mat-card class="nav-card tone-1">
          <div class="nav-card__header">
            <div class="nav-card__icon">
              <mat-icon>hourglass_empty</mat-icon>
            </div>
            <div>
              <p class="eyebrow">Operatività</p>
              <h6>Lavori & Workflow</h6>
            </div>
          </div>

          <div class="nav-card__body">
            <a routerLink="/incarichi/lavori-in-corso"> Lavori in Corso</a>
            <a routerLink="/incarichi/in-attesa-di-sopralluogo">Sopralluoghi</a>
            <a routerLink="/incarichi/scrivania-digitale">Scrivania digitale</a>
            <a routerLink="/incarichi/workflow">Workflow</a>
          </div>
        </mat-card>
      </div>

      <div class="card-wrapper">
        <mat-card class="nav-card tone-2">
          <div class="nav-card__header">
            <div class="nav-card__icon">
              <mat-icon>border_color</mat-icon>
            </div>
            <div>
              <p class="eyebrow">Incarichi</p>
              <h6>Inserimento Rapido</h6>
            </div>
          </div>

          <div class="nav-card__body">
            <a routerLink="/incarichi">Ricerca</a>
            <a routerLink="/incarichi/inserisci">Inserimento</a>
            <a routerLink="/incarichi/inserimento_da_portale"
              >Inserimento da Portale</a
            >
          </div>
        </mat-card>
      </div>

      <div class="card-wrapper">
        <mat-card class="nav-card tone-3">
          <div class="nav-card__header">
            <div class="nav-card__icon">
              <mat-icon>archive</mat-icon>
            </div>
            <div>
              <p class="eyebrow">Anagrafiche</p>
              <h6>Archivio</h6>
            </div>
          </div>

          <div class="nav-card__body">
            <a routerLink="/compagnie">Compagnie</a>
            <a routerLink="/ispettorati">Ispettorati</a>
            <a routerLink="/agenzie">Agenzie/Broker</a>
            <a routerLink="/polizze">Polizze</a>
            <a *ngIf="user?.studio_id == 1" routerLink="/cga-modelli-compagnie"
              >Modelli Compagnie</a
            >
          </div>
        </mat-card>
      </div>

      <div class="card-wrapper">
        <mat-card class="nav-card tone-4">
          <div class="nav-card__header">
            <div class="nav-card__icon">
              <mat-icon>dvr</mat-icon>
            </div>
            <div>
              <p class="eyebrow">Rubrica</p>
              <h6>Fabbricati & Soggetti</h6>
            </div>
          </div>

          <div class="nav-card__body">
            <a routerLink="/fabbricati">Schede Fabbricati</a>
            <a routerLink="/altri-soggetti">Altri Soggetti</a>
          </div>
        </mat-card>
      </div>

      <div class="card-wrapper">
        <mat-card class="nav-card tone-5">
          <div class="nav-card__header">
            <div class="nav-card__icon">
              <mat-icon>bar_chart</mat-icon>
            </div>
            <div>
              <p class="eyebrow">Analisi</p>
              <h6>Statistiche & Reports</h6>
            </div>
          </div>

          <div class="nav-card__body">
            <a routerLink="/statistiche/medie-restituzioni"
              >Statistiche & Reports</a
            >
            <a routerLink="/statistiche/ricevuti-e-restituiti"
              >Ricevuti & Restituiti</a
            >
            <a routerLink="/statistiche/quadro-riassuntivo"
              >Quadro Riassuntivo</a
            >
            <a routerLink="">Performance</a>
          </div>
        </mat-card>
      </div>

      <div class="card-wrapper">
        <mat-card class="nav-card tone-6">
          <div class="nav-card__header">
            <div class="nav-card__icon">
              <mat-icon>euro_symbol</mat-icon>
            </div>
            <div>
              <p class="eyebrow">Pagamenti</p>
              <h6>Amministrazione</h6>
            </div>
          </div>

          <div class="nav-card__body">
            <a routerLink="/pagamenti/emolumenti">Emolumenti</a>
            <a routerLink="/pagamenti/parcelle">Parcelle</a>
            <a routerLink="/pagamenti/riparazioni">Riparazioni</a>
          </div>
        </mat-card>
      </div>
    </div>

    <div *ngIf="map_enabled" class="map-block">
      <div class="section-header">
        <div>
          <h5>Mappa sopralluoghi</h5>
          <p class="section-sub">Visualizza gli appuntamenti sul territorio.</p>
        </div>
      </div>
      <mappa-sopralluoghi></mappa-sopralluoghi>
    </div>

    <div
      *ngIf="
        stats?.attesaSopralluogo != null &&
        stats?.daControllare != null &&
        stats?.daEvadere != null &&
        stats?.AC != null
      "
      class="stats-block"
    >
      <div class="section-header">
        <div>
          <h5>Andamento Rapido</h5>
          <p class="section-sub">Osserva la progressione degli incarichi</p>
        </div>
      </div>

      <div class="stats-container">
        <div class="stat-card">
          <p class="stat-label">In lavorazione</p>
          <p class="stat-value">{{ stats.inLavorazione }}</p>
        </div>
        <div class="stat-card">
          <p class="stat-label">Attesa sopralluogo</p>
          <p class="stat-value">{{ stats.attesaSopralluogo }}</p>
        </div>
        <div class="stat-card">
          <p class="stat-label">Da controllare</p>
          <p class="stat-value">{{ stats.daControllare }}</p>
        </div>
        <div class="stat-card">
          <p class="stat-label">Da evadere</p>
          <p class="stat-value">{{ stats.daEvadere }}</p>
        </div>
        <div
          class="stat-card stat-ac"
          [style.border-color]="getPercentageColor(stats.AC)"
        >
          <p class="stat-label">Rapporto A/C</p>
          <p class="stat-value" [style.color]="getPercentageColor(stats.AC)">
            {{ stats.AC }} %
          </p>
        </div>
      </div>
    </div>

    <div *ngIf="statsAnno" class="stats-block">
      <div class="section-header">
        <div>
          <h5>Statistiche Anno Corrente</h5>
          <p class="section-sub">Riepilogo incarichi dell'anno in corso</p>
        </div>
      </div>

      <div class="stats-container">
        <div class="stat-card">
          <p class="stat-label">Ricevuti</p>
          <p class="stat-value">{{ statsAnno.ricevuti }}</p>
        </div>
        <div class="stat-card">
          <p class="stat-label">Evasi</p>
          <p class="stat-value">{{ statsAnno.evasi }}</p>
        </div>
        <div class="stat-card">
          <p class="stat-label">Da evadere</p>
          <p class="stat-value">{{ statsAnno.da_evadere }}</p>
        </div>
        <div class="stat-card">
          <p class="stat-label">Videoperizie</p>
          <p class="stat-value">{{ statsAnno.videoperizie }}</p>
        </div>
        <div class="stat-card">
          <p class="stat-label">Riparazioni</p>
          <p class="stat-value">{{ statsAnno.riparazioni }}</p>
        </div>
      </div>
    </div>
  </div>
</custom-sidebar>

<ng-template #incarichiUrgentiModal>
  <div class="modal-header">
    <h4 class="modal-title">
      Incarichi Urgenti ({{ incarichiUrgenti?.length }})
    </h4>
  </div>

  <div class="modal-body">
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Numero</th>
            <th>Stato</th>
            <th>Tipologia di danno</th>
            <th>Assicurato</th>
            <th>Riserva Danno</th>
            <th>Data Incarico</th>
            <th>Ultima Interlocutoria</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let incarico of incarichiUrgenti">
            <td>
              <a
                [routerLink]="['/incarichi', incarico.id]"
                (click)="closeModal()"
              >
                {{ incarico?.humanIdentifier }}
              </a>
            </td>
            <td>{{ incarico?.stato?.nome }}</td>
            <td>{{ incarico?.tipo_danno?.nome }}</td>
            <td>{{ incarico?.polizza?.contraente?.humanIdentifier }}</td>
            <td>{{ incarico?.riserva_di_danno_range }}</td>
            <td>{{ incarico?.data?.format("L") }}</td>
            <td>
              {{ getUltimaInterlocutoria(incarico)?.format("L") }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">
      Chiudi
    </button>
  </div>
</ng-template>
